var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckbox = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#D4D9E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8254 9.23491C17.0638 8.95438 17.4845 8.92026 17.7651 9.15872C18.0456 9.39718 18.0797 9.8179 17.8413 10.0984L12.1746 16.7651C11.9324 17.05 11.5033 17.08 11.2238 16.8316L8.22376 14.1649C7.94858 13.9203 7.92379 13.4989 8.1684 13.2238C8.41301 12.9486 8.83439 12.9238 9.10958 13.1684L11.6001 15.3822L16.8254 9.23491Z",
    fill: "white",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckbox);
export default ForwardRef;